import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress,
  DialogContentText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

const RetryMethod = () => {
  const [data, setData] = useState<any>(null);
  const [msisdn, setmsisdn] = useState("");

  const [action, setAction] = useState<Boolean>(false);
  const agGridRef = useRef<AgGridReact | null>(null);
  const [Open, setOpen] = useState<boolean>(false);
  const [actionRequest, setActionRequest] = useState<Boolean>(false);
  const [product, setProduct] = useState<number>(1);
  const [activedata, setActiveData] = useState<any>(null);
  const [retryNote, setRetryNote] = useState<string>("");
  const [ipAddress, setIpAddress] = useState<string>("");

  useEffect(() => {
    getUserIpAddress();
  }, []);

  const getUserIpAddress = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      const userIpAddress = data?.ip || "";

      setIpAddress(userIpAddress);
      return userIpAddress;
    } catch (error) {
      return "";
    }
  };

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };
  const ActionsCellRenderer: React.FC<{ data: any }> = ({ data }) => {
    return (
      <Button
        onClick={() => {
          setOpen(true);
          setActiveData(data);
          setRetryNote("");
        }}
        disabled={data.IsRetryAvailable === "False"}
        className="dButton dButton2"
        variant="contained"
        style={{ width: "110px", height: "32px" }}
      >
        {" "}
        Retry
      </Button>
    );
  };
  const columnDefs: ColDef[] = [
    {
      field: "Account",
      headerName: "Account",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Msisdn",
      headerName: "Msisdn",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "CallingPackageId",
      headerName: "CallingPackageId",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Email",
      headerName: "Email",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Name",
      headerName: "Bundle Name",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "IsRenew",
      headerName: "IsRenew",
      filter: true,
      resizable: true,
      sortable: true,
      cellDataType: "string",
    },
    {
      field: "PaymentMethod",
      headerName: "PaymentMethod",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "CreatedDate",
      headerName: "CreatedDate",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "LastExecutionDate",
      headerName: "LastExecutionDate",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "IsSuccess",
      headerName: "IsSuccess",
      filter: true,
      resizable: true,
      sortable: true,
      cellDataType: "string",
    },
    {
      field: "ErrorMessage",
      headerName: "ErrorMessage",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "ErrorCode",
      headerName: "ErrorCode",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "ReExecuteCount",
      headerName: "ReExecuteCount",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "IsActive",
      headerName: "IsActive",
      filter: true,
      resizable: true,
      sortable: true,
      cellDataType: "string",
    },
    {
      headerName: "Actions",
      cellRenderer: ActionsCellRenderer,
    },
  ];

  const handleGetBundles = async () => {
    setData(null);
    toast.dismiss();
    if (msisdn.trim().length > 9) {
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please enter valid  input.");
    }
  };

  const handleCloseRetryDialog = () => {
    setOpen(false);
    setRetryNote("");
  };

  const bundleUpdateRequest = async (Id: any) => {
    toast.dismiss();
    if (!retryNote.trim()) {
      toast.error("Please enter a Note.");
      return;
    }

    setActionRequest(true);
    const userIpAddress = ipAddress || (await getUserIpAddress());
    await axiosInterceptorInstance
      .put(`/dashboard/ChangePaymentMethod`, {
        Id: Id,
        Product: product == 1 ? "THM" : "RWG",
        Note: retryNote.trim(),
        IpAddress: userIpAddress,
      })
      .then((res: any) => {
        const responseData = JSON.parse(res.data.body);
        if (responseData.message != "") {
          toast.info(responseData.message);
          requestBundles();
        }
      })
      .catch((error: any) => {
        handleCloseRetryDialog();
        setActionRequest(false);
      })
      .finally(() => {
        handleCloseRetryDialog();
        setActionRequest(false);
        setData(null);
      });
  };
  const requestBundles = async () => {
    await axiosInterceptorInstance
      .get(
        `/dashboard/GetPaymentMethod?MSISDN=${msisdn.trim()}&Product=${product}`,
      )
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (apiresponse.Data.length == 0) {
          toast.error("Record not found.");
        } else {
          setData(apiresponse.Data);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Retry Method</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={5}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel
                  id="demo-simple-select-label"
                  style={{ background: "#fff", padding: " 0 5px 0px 0px" }}
                >
                  Product
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="anbu"
                  className="selectControl"
                  autoWidth
                  value={product}
                  onChange={(e: any) => {
                    setProduct(parseInt(e.target.value));
                  }}
                >
                  <MenuItem value="1">THM</MenuItem>
                  <MenuItem value="6">RWG</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={5}>
              <TextField
                className="formControl"
                label="MSISDN"
                variant="outlined"
                value={msisdn}
                onChange={(e) => setmsisdn(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>

            <Grid item xs={2}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
        }}
      >
        <button
          className="small-btn"
          style={{ visibility: data ? "visible" : "hidden" }}
          onClick={() => {
            if (data) {
              exportGridDataAsCSV();
            }
          }}
        >
          Export as CSV
        </button>
      </div>
      {data && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={8}
            pagination={true}
            domLayout="autoHeight"
            rowData={data}
            enableCellTextSelection={true}
            columnDefs={columnDefs}
          ></AgGridReact>
        </div>
      )}
      {activedata && (
        <Dialog
          open={Open}
          onClose={handleCloseRetryDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Retry Confirmation"}
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Would you really like to Retry this ?
            </DialogContentText>
            <TextField
              className="formControl"
              label="Note"
              value={retryNote}
              onChange={(e) => setRetryNote(e.target.value)}
              fullWidth
              multiline
              minRows={3}
              required
              margin="normal"
              inputProps={{ maxLength: 500 }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              className="dButton dButton2 dbuttonSec"
              onClick={handleCloseRetryDialog}
            >
              Cancel
            </Button>
            <div style={{ width: "30px" }}></div>
            {!actionRequest && (
              <Button
                variant="contained"
                className="dButton dButton2"
                onClick={() => {
                  bundleUpdateRequest(activedata.Id);
                }}
                autoFocus
              >
                Retry
              </Button>
            )}
            {actionRequest && (
              <Button className="dButton dButton2" variant="contained">
                <CircularProgress color="inherit" size={30} />
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}
    </motion.div>
  );
};

export default RetryMethod;
